import axios from "axios";
import authHeader from "./auth-header";
import { toast } from "react-toastify";

export const fetchAllPricelists = (filters = {}) => {
  console.log({filters});
  let queryArr = [];
  for (let key in filters) {
    queryArr.push(`${key}=${encodeURIComponent(filters[key])}`);
  }
  let url = "?" + queryArr.join("&");
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/pricelist${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOnePricelist = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/pricelist/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createPricelist = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/pricelist/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updatePricelist = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/pricelist/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const uploadPricelist = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/pricelist/upload`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.filePath;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deletePricelist = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/pricelist/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchPricelistsByVendor = (vendorId) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/pricelist/vendor/${vendorId}`, { headers: authHeader() })
    .then((response) => {
      return response.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const generatePricelistPrintReport = (pricelistId) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/pricelist/${pricelistId}/print-report`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Failed to generate pricelist report");
      throw err;
    });
};
